var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{attrs:{"resize":"none","readonly":"","type":"textarea","rows":13},model:{value:(_vm.contentData.output_content),callback:function ($$v) {_vm.$set(_vm.contentData, "output_content", $$v)},expression:"contentData.output_content"}}),_c('button',{staticClass:"create_but",on:{"click":_vm.copy}},[_vm._v("复制内容")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }